import React from 'react'
import ReactDOM from 'react-dom/client'
import SomosTejasChatbot from './components/SomosTejasChatbot'
import './index.css'

// Detect if we're running in an iframe (widget mode)
const isWidget = window !== window.parent || window.location.pathname === '/widget'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SomosTejasChatbot isWidget={isWidget} />
  </React.StrictMode>,
) 